export const GET_LEAD_PREVIEW = 'GET_LEAD_PREVIEW';
export const GET_LEAD_PRIMARY_INFORMATION = 'GET_LEAD_PRIMARY_INFORMATION';
export const GET_KANBAN_LINK = 'GET_KANBAN_LINK';
export const SET_RESIDENTIAL_ASSIGNMENT = 'SET_RESIDENTIAL_ASSIGNMENT';
export const CLEAR_LEAD_PREVIEW = 'CLEAR_LEAD_PREVIEW';
export const UPDATE_QUALITY_CONTROL = 'UPDATE_QUALITY_CONTROL';
export const SET_CONVERTING_LEAD = 'SET_CONVERTING_LEAD';